

























import Vue from 'vue'

interface ComponentData {
  toolsMenu1: boolean
  toolsMenu2: boolean
  selectedTool: any | null
  toolsItems: any[]
}

export default Vue.extend({
  name: 'ToolsTreeMenu',

  props: {
    showMenu: Boolean
  },

  data (): ComponentData {
    return {
      toolsMenu1: false,
      toolsMenu2: false,
      selectedTool: null,
      toolsItems: [
        {
          id: 1, name: 'MOD/REP-Funktionen', children: [
            { id: 11, name: 'Material, Arbeit und Rabatt neu berechnen' },
            { id: 12, name: 'Material, Arbeit und Rabatt neu berechnen, ohne Option 2050' },
            { id: 13, name: 'Direktbeschaffung erstellen' },
            { id: 14, name: 'Direktbeschaffung Oel erstellen' },
            { id: 15, name: 'Übernahme zu Auftrag' },
            { id: 16, name: 'Spezialarbeiten einfüge' },
            { id: 17, name: 'Gesamtpreis bis inkl. Position 1002 ausgeben' },
          ]
        },
        {
          id: 2, name: 'Projekt verknüpfen', children: null
        },
        {
          id: 3, name: 'Teilzahlungsfunktionen', children: [
            { id: 31, name: 'Teilzahlungposition einfügen' },
            { id: 32, name: 'Schlussposition einfügen' }
          ]
        },
        {
          id: 4, name: 'Zuzüglich AG oder Abzüglich AG einfügen', children: [
            { id: 41, name: 'Position abzüglich AB einfügen' },
            { id: 42, name: 'Position zuzüglich AB einfügen' }
          ]
        },
        {
          id: 5, name: 'Zuzüglich oder Abzüglich einfügen', children: [
            { id: 51, name: 'Position abzüglich einfügen' },
            { id: 52, name: 'Position zuzüglich einfügen' }
          ]
        },
      ],
    }
  },

  methods: {
    onToolsClick (item: any): void {
      if(item.children) {
        this.toolsMenu2 = true
        this.selectedTool = item
      } else {
        this.toolsMenu1 = false
        this.toolsMenu2 = false
        this.selectedTool = null
        console.log('Run function')
      }
    },
  },

  mounted () {

  }

})
